module.exports = __webpack_public_path__ + "static/media/cat.c609a041.svg";